import { render, staticRenderFns } from "./study-participant-status-maps.vue?vue&type=template&id=c1220610&scoped=true&"
import script from "./study-participant-status-maps.vue?vue&type=script&lang=js&"
export * from "./study-participant-status-maps.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-status-maps.vue?vue&type=style&index=0&id=c1220610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1220610",
  null
  
)

component.options.__file = "study-participant-status-maps.vue"
export default component.exports